const PURCHASED_PHOTO_PRICING_STATUS = {
  PENDING: 'PENDING',
  SHIPPED: 'SHIPPED',
  PENDING_REVIEW: 'PENDING_REVIEW',
};

export { PURCHASED_PHOTO_PRICING_STATUS };
